export const CREATE_MODE = 'CREATE_MODE';
export const UPDATE_MODE = 'UPDATE_MODE';
